/**
 * journal_page — the decor page some maps leave on a ledge (scene.natureProps).
 * Split out of propTextures.ts (file-size ceiling) with its 2026-10-08 redraw.
 */

/** Convert a 0xRRGGBB number to an SVG `#rrggbb` hex string. */
function hex(color: number): string {
  return '#' + color.toString(16).padStart(6, '0');
}

/** The page's raster size: twice its 30×14 drawing (D41, 2026-10-09) — at the
 *  old size it read as a white speck, so placements grew to about a pickup's
 *  size and the texture is drawn at that size to stay crisp. */
export const JOURNAL_PAGE_BASE_SIZE = { w: 60, h: 28 } as const;

/** A page lying flat in perspective under a stone (drawn in a 30×14 box,
 *  scaled to {@link JOURNAL_PAGE_BASE_SIZE}). */
export function journalPageBody(parchment: number): string {
  return `<g transform="scale(2)">${journalPageDrawing(parchment)}</g>`;
}

function journalPageDrawing(parchment: number): string {
  // Stream note 16 (2026-10-08): the page used to stand upright on a ledge,
  // stretched tall, and read as a pickup floating in the air. It is set
  // dressing, so it now LIES on the ground in perspective, weighted by a
  // stone, one corner lifting in the wind, with a contact shadow.
  const p = hex(parchment);
  const edge = '#c8b880';
  const ink = '#4a3a2a';
  const stone = '#5d6158';
  const stoneHi = '#8a8f84';
  return `
    <ellipse cx="15" cy="12.4" rx="14.2" ry="1.5" fill="#000" opacity="0.3" />
    <path d="M1.5 11.6 L5.2 6.6 L25.6 5.6 L28.6 11 Q22 12.6 14.5 12.4 Q6.5 12.6 1.5 11.6 Z" fill="${p}" />
    <path d="M1.5 11.6 Q6.5 12.6 14.5 12.4 Q22 12.6 28.6 11 L28.4 11.8 Q22 13.3 14.5 13.1 Q6.5 13.3 1.6 12.3 Z" fill="${edge}" opacity="0.8" />
    <path d="M25.6 5.6 L28.6 11 L24.6 9.2 Z" fill="${edge}" />
    <path d="M7.5 8.6 h11 M6.5 10.2 h14" stroke="${ink}" stroke-width="0.5" opacity="0.45" stroke-linecap="round" />
    <path d="M10 7.2 Q11.6 4 15.2 4.3 Q18.4 4.8 17.9 7.4 Q14 8.6 10 7.2 Z" fill="${stone}" />
    <path d="M11.3 5.9 Q13.2 4.7 15.4 4.9" fill="none" stroke="${stoneHi}" stroke-width="0.7" opacity="0.6" stroke-linecap="round" />`;
}
